<template>
  <div class="app-deactivate">
    <b-row v-if="!success">
      <b-col class="heading-success"><slot name="txtHeading"><h2>Tarif-Paket deaktivieren</h2></slot></b-col>
    </b-row>
    <b-row v-if="success">
      <b-col class="heading-success"><slot name="txtSuccessHeading"><h2>Tarif-Paket deaktiviert</h2></slot></b-col>
    </b-row>
    <ListOptionsDetails :item-list="[refactoredItem]" :show-header="true"></ListOptionsDetails>
    <b-row class="button-row">
      <Buttons ref="button" @cancel="cancelItem" @refresh="$emit('refresh')" @deactivate="deactivateItem" :item="item" :success="success">
        <template v-for="slot in possibleChildSlotsFor('Buttons')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Buttons>
    </b-row>
  </div>
</template>
<script>

import slotProxy from '../../../../../../mixins/slotProxy'
import Buttons from './Buttons.vue'
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import FileSaver from 'file-saver'
import ListOptionsDetails from '@/components/process/generic/Tariff/fyve/ListOptionsDetails.vue'

export default {
  name: 'Deactivate',
  components: { Buttons, ListOptionsDetails },
  mixins: [
    slotProxy()
  ],
  data () {
    return {
      visible: false,
      loading: false,
      success: false
    }
  },
  methods: {
    download: function () {
      const me = this
      axios.get(this.contractUrl, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    },
    ...mapActions('tariffs', [
      'cancelPendingTariffChange',
      'confirmCancelTariff',
      'deactivateTariffOption',
      'saveSelectedOptions',
      'cancelTariffOptionConfirm'
    ]),
    cancelItem () {
      const me = this
      this.$refs.button?.changeLoading(true)
      this.cancelPendingTariffChange({
        tariffId: me.item.tariffId
      }).then((response) => {
        if (response) {
          this.success = true
        }
        this.$refs.button?.changeLoading(false)
      }, () => {
        this.$refs.button?.changeLoading(false)
      })
    },
    async deactivateItem () {
      this.$refs.button?.changeLoading(true)
      if (this.item.tariffId) {
        await this.confirmCancelTariff().then((response) => {
          if (response) {
            this.success = true
            this.$store.commit('tariffs/forceUpdate', true)
            this.$refs.button?.changeLoading(false)
          }
        }, () => {
          this.$refs.button?.changeLoading(false)
        })
        this.$refs.button?.changeLoading(false)
      }
      if (this.item.tariffoptionId) {
        const comp = this
        await this.cancelTariffOptionConfirm().then((response) => {
          if (response) {
            comp.success = true
            this.$store.commit('tariffs/forceUpdate', true)
            comp.$refs.button?.changeLoading(false)
          }
        }, () => {
          comp.$refs.button?.changeLoading(false)
        })
        comp.$refs.button?.changeLoading(false)
      }
      if (this.item.serviceOptionId) {
        const comp = this
        await this.saveSelectedOptions({ value: false }).then((response) => {
          if (response) {
            comp.success = true
            this.$store.commit('tariffs/forceUpdate', true)
            comp.$refs.button?.changeLoading(false)
          }
        }, () => {
          comp.$refs.button?.changeLoading(false)
        })
        comp.$refs.button?.changeLoading(false)
      }
    }
  },
  computed: {
    ...mapGetters('tariffs', [
      'getContractUrl'
    ]),
    contractUrl: function () {
      return this.getContractUrl
    },
    refactoredItem: function () {
      if (this.item.serviceOptionId) {
        return {
          ...this.item,
          id: this.item.serviceOptionId
        }
      } else {
        return this.item
      }
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
